import * as React from "react";
import {cx} from "emotion";

import "./header-options.scss";

import {cs}               from "@Common/react/chain-services";
import {joinJsx}          from "@Common/react/join-jsx";
import {keyed}            from "@Common/react/keyed";
import {InformationBadge} from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";
import {Radio}            from "@Common/ui-components/heavy/common/design2/radio/radio";
import {Tooltip2}         from "@Common/ui-components/heavy/common/design2/tooltip-2/tooltip-2";

export const HeaderOptions = ({className=undefined, list,}) => cs(
    ({}) => (
        <div className={cx("header-options-9w2", className)}>
            {list.map((item) => cs(
                keyed(item.key),
                ["disabled", (_, next) => next(item.disabled)],
                ["tooltip", ({disabled}, next) => !disabled?.tooltip ? next() : Tooltip2({
                    getMessage: () => disabled.tooltip,
                    next,
                })],
                ({tooltip, disabled}) => {
                    const labels = item.labels;
                    return (
                        <div
                            className={cx("item", {disabled})}
                            onMouseEnter={tooltip?.onMouseEnter}
                            onMouseLeave={tooltip?.onMouseLeave}
                            onClick={() => !disabled ? item.onSelect() : tooltip?.onClick()}
                        >
                            <div className="radio">
                                {Radio({
                                    selected: item.selected,
                                    xdQaName: labels[0].text,
                                    disabled,
                                })}
                            </div>
                            <div className="text">
                                <div className="title">
                                    {joinJsx(
                                        item.labels.map((label) => (
                                            <div className="label" xd-qa-type="label" xd-qa-name={label.text}>
                                                <div className="text">
                                                    {label.text}
                                                </div>

                                                {label.toolTip && !tooltip && (
                                                    InformationBadge({
                                                        getTooltip: label.toolTip,
                                                        xdQaName: label.text + " tooltip"
                                                    })
                                                )}
                                            </div>
                                        )),
                                        () => " ",
                                    )}
                                </div>
                                {tooltip && (
                                    <div
                                        className="tooltip"
                                        ref={tooltip?.ref}
                                    >
                                        {tooltip?.render()}
                                    </div>
                                )}
                                <div
                                    className="description"
                                    xd-qa-type="label"
                                    xd-qa-name={labels[0].text + " Description"}
                                >
                                    {item.description}
                                </div>
                            </div>
                        </div>
                    );
                }
            ))}
        </div>
    ),
);
